import type { ReactNode } from 'react';
import styled from 'styled-components';

import { BracketedWrapper } from '@sorare/core/src/atoms/BracketedWrapper/index.tsx';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, BrandXL } from '@sorare/core/src/atoms/typography';

const StyledBracketedWrapper = styled(BracketedWrapper)`
  gap: var(--unit);
  padding: var(--unit) var(--double-unit);
`;

type Props = {
  icon?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
};

export const SecondaryPageHeader = ({ icon, title, subtitle }: Props) => {
  return (
    <Vertical center gap={1}>
      <StyledBracketedWrapper>
        {!!icon && <span>{icon}</span>}
        <BrandXL>{title}</BrandXL>
      </StyledBracketedWrapper>
      {!!subtitle && <BodyL className="text-center">{subtitle}</BodyL>}
    </Vertical>
  );
};
